module.exports = __webpack_public_path__ + "img/donkey_carrot.706c8b6b.jpg";